import { Layout as AntLayout, Menu } from 'antd'
import {
  HomeOutlined,
  HeartOutlined,
  SettingOutlined,
  LogoutOutlined,
} from '@ant-design/icons'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../utils/redux/store'
import { logout } from '../utils/redux/authSlice'
import './MainLayout.scss'

const { Header, Content } = AntLayout

export default function MainLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation('common')
  const dispatch = useAppDispatch()

  const handleLogout = () => {
    dispatch(logout())
  }

  const menuItems = [
    {
      key: '/home',
      icon: <HomeOutlined />,
      label: t('home'),
      onClick: () => navigate('/home'),
    },
    {
      key: '/library',
      icon: <HeartOutlined />,
      label: t('library'),
      onClick: () => navigate('/library'),
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: t('settings'),
      onClick: () => navigate('/settings'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('logout'),
      onClick: handleLogout,
      style: { marginLeft: 'auto' },
    },
  ]

  const selectedKey = menuItems.find((item) => location.pathname.startsWith(item.key))?.key || '/home'

  return (
    <AntLayout className="main-layout">
      <Header className="main-header">
        <div className="logo">Music TMM</div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={menuItems}
          className="main-menu"
        />
      </Header>
      <Content className="main-content">
        <Outlet />
      </Content>
    </AntLayout>
  )
}
